import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/Styles/index.css';
import App from './App';
import { store } from './store'
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext';
import { SelectedCompanyProvider } from './contexts/SelectedCompanyContext';
import { AdminProvider } from './contexts/AdminContext';
import { SelectedYearProvider } from './contexts/SelectedYearContext';
import { WorkerProvider } from './contexts/WorkerContext';

const el = document.getElementById('root');
const root = ReactDOM.createRoot(el);

root.render(
    <BrowserRouter>
        <Provider store={store} >
            <AuthProvider>
                <AdminProvider>
                <SelectedCompanyProvider>
                    <SelectedYearProvider>
                        <WorkerProvider>
                    <React.StrictMode>
                                <App />
                    </React.StrictMode>
                    </WorkerProvider>
                    </SelectedYearProvider>
                </SelectedCompanyProvider>
                </AdminProvider>
            </AuthProvider>
        </Provider>
    </BrowserRouter>  
)